import gql from 'graphql-tag';

export const GET_GLOBAL_BROADCASTS = gql`
  query GlobalBroadcasts {
    broadcast {
      globalBroadcasts {
        broadcastId
        type
        title
        status
        effectiveDateTime
      }
    }
  }
`;
